import { Registration } from '@/api/dtos';
import { IValidationError } from '@ngt/forms';
import { IFormSubmit } from '@ngt/forms-core';
import { useCallback } from 'react';
import { enqueueSnackbar } from 'notistack';

/**
 * Hook that provides a standard validation failure handler for forms.
 * Shows a warning snackbar when validation fails.
 * @returns A callback function to be used as onSubmitValidationFailed handler
 */
export const useFormSubmitValidationFailed = (): IFormSubmit<Registration, IValidationError> => {
    return useCallback(async () => {
        enqueueSnackbar(
            `Your registration hasn't been saved. Please complete the mandatory fields and try again.`,
            { variant: 'warning' }
        );
    }, []);
};
